export default {
    title: 'Cấu hình mô hình AI',
    permissionAlert: 'Trang này chỉ quản trị viên mới có thể chỉnh sửa. API Key được mã hóa và quản lý bởi quản trị viên hệ thống ở backend; trang này chỉ kiểm soát công tắc nghiệp vụ và lựa chọn mô hình.',
    providerSection: 'Cấu hình mô hình chung',
    imageModelSection: 'Cấu hình mô hình hình ảnh',
    taskSection: 'Phân công mô hình theo nhiệm vụ',
    taskDesc: 'Chỉ định mô hình cho từng nhiệm vụ AI',
    usageSection: 'Thống kê sử dụng (tháng này)',
    connected: '● Đã kết nối',
    notConnected: '○ Chưa kết nối',
    connectionStatus: 'Trạng thái kết nối',
    errorStatus: 'Lỗi kết nối',
    unknownStatus: 'Không rõ',
    errorHint: 'Lỗi kết nối API, liên hệ quản trị viên',
    connectedStatus: 'Đã kết nối',
    notConnectedStatus: 'Chưa kết nối',
    availableModels: 'Mô hình khả dụng',
    checkHint: 'Các mô hình được chọn có thể dùng trong nhiệm vụ AI',
    notConnectedHint: 'Liên hệ quản trị viên để hoàn tất tích hợp API',
    recommended: 'Đề xuất',
    adminOnlyTooltip: 'Chỉ quản trị viên mới có thể chỉnh sửa',
    toggleFailed: 'Thao tác thất bại, vui lòng thử lại',
    saveOk: 'Đã lưu cấu hình',
    noModels: 'Chưa có mô hình khả dụng',
    modelConfigNotFound: 'Không tìm thấy cấu hình mô hình, vui lòng làm mới và thử lại',
    configServiceUnavailable: 'Dịch vụ cấu hình AI tạm thời không khả dụng, vui lòng thử lại sau',
    provider: {
      anthropic: 'Anthropic (Claude)',
      openai: 'OpenAI (GPT)',
      google: 'Google (Gemini)',
    },
    task: {
      name: 'Nhiệm vụ',
      desc: 'Mô tả',
      primary: 'Mô hình chính',
      backup: 'Mô hình dự phòng',
      noBackup: 'Không dùng dự phòng',
      random: 'Luân phiên',
      primaryRequired: 'Vui lòng cấu hình mô hình chính trước',
      articleGen: '📝 Tạo bài viết',
      articleGenDesc: 'Bài đầy đủ + FAQ + Meta',
      keywordMining: '🔑 Khai thác từ khóa',
      keywordMiningDesc: 'AI tìm từ khóa',
      scoring: 'Điểm SEO/GEO',
      scoringDesc: 'Chấm điểm hỗ trợ AI',
    },
    usage: {
    title: 'Thống kê sử dụng AI (Tháng này)',
    callCount: 'Số lần gọi API',
    totalTokens: 'Token đã dùng',
    cost: 'Chi phí tháng này',
    dataSourceStub: 'Dữ liệu tạm thời, chờ kết nối ES',
    byModelTitle: 'Chi tiết theo mô hình',
    modelName: 'Mô hình',
    provider: 'Nhà cung cấp',
    callCountCol: 'Số lần gọi',
    costCol: 'Chi phí (USD)',
  },
    backupHint: '✓ Mô hình dự phòng: tự động chuyển sang dự phòng khi mô hình chính lỗi. Giới hạn ngày: dừng nhiệm vụ khi đạt giới hạn để tránh chi phí bất thường.',
};
